var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdTime04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTime04",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#75c48a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(23 56.5)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime04);
export default __webpack_public_path__ + "static/media/prodTime04.48d9ed4150b69ad9c3f1164029d53a00.svg";
export { ForwardRef as ReactComponent };